import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { motion } from "framer-motion";

const FAQS = [
  { q: "What does an AMFI Registered Mutual Fund Distributor do?", a: "An AMFI Registered Mutual Fund Distributor (ARMFD) is authorized by AMFI to recommend and execute mutual fund transactions on behalf of investors. Axomind helps you select schemes, structure SIPs, and review portfolios — within a strict compliance framework." },
  { q: "How is Axomind compensated?", a: "We earn trail commissions paid by Asset Management Companies (AMCs) on the Regular Plans we distribute, as per regulatory norms. All commissions are disclosed transparently and do not influence our scheme suggestions. We do not charge investors any separate fee." },
  { q: "What is the minimum investment to start?", a: "You can start an SIP with as little as ₹500 per month, or a lump-sum investment from ₹5,000 onwards depending on the scheme. Our HNI portfolio services typically start at ₹50 lakh portfolio size." },
  { q: "Do you serve NRI clients?", a: "Yes. We onboard NRIs from over 40 countries with fully paperless KYC, NRE/NRO investment options and FATCA-compliant documentation." },
  { q: "Are my investments safe?", a: "All investments are held directly in your name with the AMC and RTA (CAMS / KFintech). Axomind never holds client money. You can redeem, transfer or stop transactions at any time." },
  { q: "How often will my portfolio be reviewed?", a: "All investor clients receive a quarterly written portfolio review. HNI clients additionally get monthly check-ins, rebalancing alerts and annual deep-dive sessions." },
  { q: "Can I track my investments online?", a: "Yes — every client gets access to a consolidated digital dashboard with real-time NAV, XIRR, allocation and tax reports." },
  { q: "What if I am unhappy with the suggestions?", a: "You can pause, change or exit our service at any time, with no lock-in. We earn the right to your trust every quarter." },
];

export default function FAQ() {
  return (
    <section id="faqs" data-testid="faq-section" className="section relative bg-[#080808]">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <p className="text-xs tracking-[0.35em] uppercase text-[#D4AF37]">FAQs</p>
          <h2 className="font-display font-bold text-4xl sm:text-5xl text-white mt-4">
            Questions, <span className="text-gold-gradient">answered.</span>
          </h2>
        </motion.div>

        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="glass rounded-xl px-5 border-white/10 data-[state=open]:border-[#D4AF37]/40"
            >
              <AccordionTrigger className="text-left font-display font-medium text-white hover:text-[#D4AF37] hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-gray-400 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
